(() => {
  'use strict';
  function init(root = document) {
    root.querySelectorAll('.ts-page').forEach(page => {
      if (page.dataset.ready) return;
      page.dataset.ready = 'true';
      const filter = page.querySelector('.ts-filter');
      if (filter) {
        const items = [...page.querySelectorAll('.ts-service')];
        const count = page.querySelector('.ts-filter-count');
        filter.hidden = false;
        filter.addEventListener('click', event => {
          const button = event.target.closest('button[data-filter]');
          if (!button) return;
          const selected = button.dataset.filter;
          filter.querySelectorAll('button').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
          items.forEach(item => { item.hidden = selected !== 'all' && item.dataset.category !== selected; });
          count.textContent = `${items.filter(item => !item.hidden).length} services · ${button.textContent}`;
        });
        count.textContent = `${items.length} services · All services`;
      }
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  const pause = () => document.querySelectorAll('.ts-page').forEach(p => { p.dataset.paused = String(document.hidden); });
  document.addEventListener('visibilitychange', pause);
  pause();
})();
